import { RequestModel } from "./RequestModel";
import { TechnicianModel } from "./TechnicianModel";
import { ContactModel } from "./ClientModel";
import Helper, { DateFormat } from "@/services/Helper";

class PartModel
{
    constructor(obj?: PartModel)
    {
        if (obj)
        {
            Object.assign(this, obj);

            if (obj.NeededBy)
            {
                let tmp = new Date((obj.NeededBy + "").split("T")[0] + " 00:00:00");
                this.NeededBy = tmp.toUTCString();
            }

            if (obj.WorkCompleteDate)
            {
                let tmp = new Date((obj.WorkCompleteDate + "").split("T")[0] + " 00:00:00");
                this.WorkCompleteDate = tmp.toUTCString();
            }

            if (obj.Request)
            {
                this.Request = new RequestModel(obj.Request);
                this.RequestId = obj.Request.Id;
            }

            if (obj.Technician)
            {
                this.Technician = new TechnicianModel(obj.Technician);
                this.AssignedTo = obj.Technician.Id;
            }

            if (obj.Contact)
            {
                this.Contact = new ContactModel(obj.Contact);
                this.CustomerNumber = obj.Contact.CustomerNumber;
            }

        }
        else
        {
            // Set defaults for new records
            this._CreateDate = Helper.dateToInput(new Date(), DateFormat.Date);
            this.OrderStatus = 1;
        }
    }

    public Request?: RequestModel | null;

    public Technician?: TechnicianModel | null;

    public Contact?: ContactModel | null;

    public Id?: number | null;

    public CustomerNumber?: number | null;
    
    public RequestId?: number | null;
    
    public AssignedTo?: number | null;
    
    public PartDescription?: string | null;
    
    public PartNumber?: string | null;
    
    public PartsCost?: number | null;
    
    public LinkReference?: string | null;
    
    public OrderStatus?: number | null;
    
    private _WorkCompleteDate?: string | null;

    public get WorkCompleteDate (): string | null
    {
        return Helper.dateToInput(this.WorkCompleteDateAsDate, DateFormat.Date) || null;
    }

    public set WorkCompleteDate (val: string | null)
    {
        this._WorkCompleteDate = val || null;
    }

    public get WorkCompleteDateAsDate (): Date | null
    {
        if (this._WorkCompleteDate)
        {
            return Helper.dateFromString(this._WorkCompleteDate) || null;
        }

        return null;
    }
    
    public Quantity?: number | null;
    
    private _CreateDate?: string | null;

    public get CreateDate (): string | null
    {
        return Helper.dateToInput(this.CreateDateAsDate, DateFormat.Date) || null;
    }

    public set CreateDate (val: string | null)
    {
        this._CreateDate = val || null;
    }

    public get CreateDateAsDate (): Date | null
    {
        if (this._CreateDate)
        {
            return Helper.dateFromString(this._CreateDate) || null;
        }

        return null;
    }
    
    private _NeededBy?: string | null;

    public get NeededBy (): string | null
    {
        return Helper.dateToInput(this.NeededByAsDate, DateFormat.Date) || null;
    }

    public set NeededBy (val: string | null)
    {
        this._NeededBy = val || null;
    }

    public get NeededByAsDate (): Date | null
    {
        if (this._NeededBy)
        {
            return Helper.dateFromString(this._NeededBy) || null;
            
        }

        return null;
    }
    
    public OrderNumber?: string | null;
    
    public PaymentMethod?: string | null;
    
    public Reconciled?: boolean | null;
    
    public MSRP?: number | null;

    public WorkOrderId?: number | null;

    public WorkOrder?: any | null;

    public InvoiceNumber?: string | null;
    
    public RecCount?: number | null;
}

class PartModelFilter 
{
    public Id?: Array<number> = [];

    public RequestId?: Array<number> = [];
    
    public ContactId?: Array<number> = [];
    
    public TechId?: Array<number> = [];
    
    public IncludeRequest?: boolean = false;
    
    public IncludeContact?: boolean = false;
    
    public StartDate?: Date = new Date();
    
    public EndDate?: Date = new Date();
    
    public Page?: number = 0;
    
    public Size?: number = 25;
}

export { PartModel, PartModelFilter }